import React from 'react';
// import { InfoOutlined } from '@mui/icons-material';
// import Tooltip from '@mui/material/Tooltip';
import { usePersistedDataStore } from '../store';
import { getCaseStrengthPercentage, getCaseStrengthColor } from '../../utils/caseStrengthCalculator';

const CaseStrengthWidget = ({ getNegotiationObj, comp }) => {
  // Subscribe so we recompute when comps / cutoffs change (calculator uses getState())
  usePersistedDataStore((state) => state.compSheet?.[comp]);
  usePersistedDataStore((state) => state.negotiationObj?.earliestCutoffDate);

  const reportType = getNegotiationObj?.reportType || 'standard';
  const percentage = getCaseStrengthPercentage(comp, reportType).caseStrengthA ?? 0;
  const color = getCaseStrengthColor(percentage);

  return (
    <div className="flex items-center justify-center ml-2 flex-shrink-0 gap-2 relative" style={{ height: '34.5px', marginTop: '2px' }}>
      <div className="flex flex-col items-center">
        <div className="text-xs font-bold text-gray-700 whitespace-nowrap mb-0.5">Case Strength:</div>
        <div className="flex items-center gap-1">
          <div className="text-sm font-bold text-center" style={{ color, lineHeight: '1' }}>
            {percentage}%
          </div>
          {/* Info icon hidden for now.
          <Tooltip
            title={
              <div className="text-xs">
                <div className="font-semibold mb-2">Case Strength:</div>
                <div className="mb-1">
                  <span className="font-bold">Value:</span> {percentage}%
                </div>
                <div className="text-xs text-gray-300 mt-2 mb-1">Composite scoring with:</div>
                <div className="text-xs text-gray-300">• Rank-weighted support (exp decay)</div>
                <div className="text-xs text-gray-300">• Clean-head bonus (top 10)</div>
                <div className="text-xs text-gray-300">• Subject sold override (100% below IFMV / 0% at or above)</div>
              </div>
            }
            arrow
            placement="top"
          >
            <InfoOutlined
              sx={{
                fontSize: 12,
                color: '#6b7280',
                cursor: 'help',
                '&:hover': { color: '#374151' },
              }}
            />
          </Tooltip>
          */}
        </div>
      </div>
    </div>
  );
};

export default CaseStrengthWidget;
